import * as React from 'react'

/**
 * DO NOT EXTEND THIS CLASS. If you see this being extended please try to remove it
 * and replace with a simple functional component.
 *
 * Keep in mind that if you want to have a safe component that does not crash the app
 * to the ice cream cone screen when something goes wrong then wrap it in an ErrorBoundary component.
 *
 * @deprecated Do not use this. We do not want to use class based components in React.
 * With that, we want to avoid inheritance and use composition instead.
 */
export abstract class NonThrowingComponent<P = {}, S = {}> extends React.Component<P, S> {
    public render() {
        return this.renderCatch(() => this.tryRender())
    }

    public abstract tryRender(): React.ReactElement<unknown>

    // This is replaced on page load to something prettier
    // This is to avoid circular dependencies
    public renderCatch(tryRender: () => React.ReactElement<unknown>): React.ReactElement<unknown> {
        try {
            return tryRender()
        } catch (_) {
            return <div>Render Failed</div>
        }
    }
}
